const COOKIE_NAME = 'sh_ft';
const MAX_AGE_SEC = 90 * 24 * 60 * 60; // 90 days

const TRACKED_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'fbclid',
  'msclkid',
];

function isHttps() {
  return typeof window !== 'undefined' && window.location.protocol === 'https:';
}

function cookieDomain() {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname;
  if (host === 'studyhall.xyz' || host.endsWith('.studyhall.xyz')) {
    return '.studyhall.xyz';
  }
  return null;
}

function readRawCookie(name) {
  if (typeof document === 'undefined') return null;
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const [k, ...rest] = part.trim().split('=');
    if (k === name) return rest.join('=') || '';
  }
  return null;
}

function writeCookie(name, value) {
  if (typeof document === 'undefined') return;
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    'Path=/',
    `Max-Age=${MAX_AGE_SEC}`,
    'SameSite=Lax',
  ];
  const domain = cookieDomain();
  if (domain) parts.push(`Domain=${domain}`);
  if (isHttps()) parts.push('Secure');
  document.cookie = parts.join('; ');
}

function attributionFromSearch(search) {
  const q = search.startsWith('?') ? search.slice(1) : search;
  if (!q) return null;
  const params = new URLSearchParams(q);
  const out = {};
  let has = false;
  for (const key of TRACKED_KEYS) {
    const v = params.get(key);
    if (v != null && String(v).trim() !== '') {
      out[key] = String(v).trim();
      has = true;
    }
  }
  return has ? out : null;
}

export function getFirstTouchAttribution() {
  const raw = readRawCookie(COOKIE_NAME);
  if (raw == null || raw === '') return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

/** Rebuild `?utm_...` from first-touch cookie (or null if none). */
export function getFirstTouchQueryString() {
  const attr = getFirstTouchAttribution();
  if (!attr) return null;
  const params = new URLSearchParams();
  for (const key of TRACKED_KEYS) {
    const v = attr[key];
    if (v) params.set(key, v);
  }
  const s = params.toString();
  return s ? `?${s}` : null;
}

/** Capture first-touch from the current URL into sh_ft if not already set. */
export function captureFirstTouchFromUrl() {
  if (typeof window === 'undefined') return null;
  const existing = getFirstTouchAttribution();
  if (existing) return existing;

  const fromUrl = attributionFromSearch(window.location.search || '');
  if (!fromUrl) return null;

  const payload = {
    ...fromUrl,
    landing: `${window.location.pathname}${window.location.search}`,
    ts: new Date().toISOString(),
  };
  writeCookie(COOKIE_NAME, JSON.stringify(payload));
  return payload;
}
